import React, { useEffect, useRef, useState } from "react";
import "./SupplierStatementFilter.css";

interface FilterOption {
  label: string;
  value: string;
}

interface SupplierStatementFilterProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (values: { status: string | null }) => void;
  activeStatus?: string | null;
  options?: FilterOption[];
}

const DEFAULT_OPTIONS: FilterOption[] = [
  { label: "Ready", value: "ready" },
  { label: "To review", value: "to_review" },
];

const SupplierStatementFilter: React.FC<SupplierStatementFilterProps> = ({
  isOpen,
  onClose,
  onApply,
  activeStatus = null,
  options = DEFAULT_OPTIONS,
}) => {
  const [selectedStatus, setSelectedStatus] = useState<string | null>(activeStatus);
  const ref = useRef<HTMLDivElement>(null);

  
  useEffect(() => {
    if (isOpen) setSelectedStatus(activeStatus ?? null);
  }, [isOpen, activeStatus]);

  
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose();
      }
    };
    if (isOpen) document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleToggle = (value: string) => {
    setSelectedStatus((prev) => (prev === value ? null : value));
  };

  const handleApply = () => {
    onApply({ status: selectedStatus });
    onClose();
  };

  const handleReset = () => {
    setSelectedStatus(null);
    onApply({ status: null });
    onClose();
  };

  return (
    <div className="ss-filter-dropdown" ref={ref}>
      <p className="ss-filter-dropdown__title">FILTER</p>

      <div className="ss-filter-dropdown__row">
        <span className="ss-filter-dropdown__label">Status</span>
        <div className="ss-filter-dropdown__options">
          {options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`ss-filter-dropdown__pill${selectedStatus === opt.value ? " ss-filter-dropdown__pill--active" : ""}`}
              onClick={() => handleToggle(opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      <div className="ss-filter-dropdown__footer">
        <span className="ss-filter-dropdown__spacer" />
        <button type="button" className="ss-filter-dropdown__reset" onClick={handleReset}>
          Reset
        </button>
        <button type="button" className="ss-filter-dropdown__apply" onClick={handleApply}>
          Apply
        </button>
      </div>
    </div>
  );
};

export default SupplierStatementFilter;
